import styled from "styled-components";

interface ButtonGroupProps {
  bgColor?: string;
}

interface FormGroupProps {
  $fullWidth?: boolean;
}

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  inset: 0;
`;

export const ModalContent = styled.div`
  background-color: #fff;
  border-radius: 12px;
  padding: 24px;
  width: 100%;
  max-width: 90%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
`;

export const Form = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const FormGroup = styled.div<FormGroupProps>`
  display: flex;
  flex-direction: column;

  /* 👇 FAZ OCUPAR 100% DA LARGURA QUANDO NECESSÁRIO */
  ${({ $fullWidth }) =>
    $fullWidth &&
    `
      grid-column: 1 / -1;
    `}

  label {
    font-size: 14px;
    margin-bottom: 4px;
    color: #333;
  }

  input,
  select {
    padding: 10px;
    border-radius: 6px;
    border: 1px solid #ccc;
    font-size: 14px;
    width: 100%;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    background-color: transparent;
  }

  textarea {
    padding: 10px;
    border-radius: 6px;
    border: 1px solid #ccc;
    font-size: 14px;
    width: 100%;
    box-sizing: border-box;
    resize: none;
    overflow: hidden;
    min-height: 150px;
  }

  input[type="checkbox"] {
    width: 20px;
    height: 20px;
    margin-top: 8px;
    cursor: pointer;
  }

  input:focus,
  select:focus,
  textarea:focus {
    outline: 2px solid #3b82f6;
    border-color: transparent;
  }
`;

export const ButtonGroup = styled.div<ButtonGroupProps>`
  grid-column: 1 / -1;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;

  .cancel {
    background-color: #e5e7eb;
    color: #111;
  }

  .submit {
    background: ${({ bgColor }) =>
      bgColor || "linear-gradient(to right, #4f46e5, #7c3aed)"};
    color: white;
  }

  button {
    padding: 10px 20px;
    border: none;
    border-radius: 6px;
    font-weight: 500;
    cursor: pointer;
    transition: 0.2s;

    &:hover {
      opacity: 0.9;
    }
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 16px;
  background: transparent;
  border: none;
  font-size: 28px;
  color: #555;
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    color: #000;
    transform: scale(1.1);
  }
`;

export const TextArea = styled.textarea`
  flex: 1;
  width: 100%;

  height: 36px;
  min-height: 36px;

  padding: 6px 8px;

  border-radius: 8px;
  border: 1px solid #ccc;

  resize: none;
  overflow: hidden;

  line-height: 1.2;

  box-sizing: border-box;
`;